
module.exports = class WebsocketTransport {
	constructor({
		host,
		onMessage,
		getId,
		transport
	}) {
		this._host = host;
		this._transport = transport;
		this._connection = null;

		this._onMessage = onMessage;
		this._getId = getId;
	}

	connect() {
		if (this._connection)
			return this._connection.connect();

		this._connection = this._transport.connect(
			(location.protocol === 'https:' ? 'wss://' : 'ws://') + this._host,
			{ transports: ['websocket'] }
		);

		this._connection.on('connect', (...args) => this._authorize(...args));
		this._connection.on('message', (...args) => this._inbox(...args));
		this._connection.on('disconnect', () => this.connect());

		return this._connection;
	}

	disconnect() {
		this._connection.disconnect();
	}

	send(map) {
		this._connection.send(this._toJson(map));
	}

	_log(...args) {
		return __DEV__ && console.log(`[WebsocketTransport]: ->`, ...args);
	}

	_toJson(map) {
		return JSON.stringify(typeof map === 'object' ? map : {});
	}

	_authorize() {
		this.send({
			method: 'auth',
			login: this._getId()
		});
	}

	_inbox(message) {
		try {
			message = JSON.parse(message);
			
			this._log('incomming message', message);
			this._onMessage(message);
		} catch (e) {
			this._log('message parse error', e);
		}
	}

}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/websocket-transport/index.es.js